import "./popcard.scss";

function PopCard({ icon, title, value, onClick }) {
  // The component receives the icon from the parent component.
  // آیکون از کامپوننت والد دریافت می‌شود.

  return (
    <div onClick={onClick} className="pop-card">
      {/* Display the icon provided by the parent component. */}
      {/* نمایش آیکونی که توسط کامپوننت والد ارسال شده است. */}
      <span className="pop-card_span">
        <img src={icon} className="pop-card_icon" alt="" />

        {/* Display the value provided by the parent component. */}
        {/* نمایش مقدار ارسال‌شده توسط کامپوننت والد. */}
        <p className="pop-card_value">{value}</p>
      </span>

      {/* Display the title provided by the parent component. */}
      {/* نمایش عنوان ارسال‌شده توسط کامپوننت والد. */}
      <p className="pop-card_title">{title}</p>
    </div>
  );
}

export default PopCard;
